// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Заглушка «нужно сменить пароль» при возобновлении сессии (см. MustChangePassword.tsx). */
.core-login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-0);
}
.core-login-card {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  border: 1px solid var(--border-1);
  border-radius: var(--radius-lg, 12px);
  background: var(--bg-1);
}
`, "",{"version":3,"sources":["webpack://./src/screens/MustChangePassword.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,uBAAuB;AACzB","sourcesContent":["/* Заглушка «нужно сменить пароль» при возобновлении сессии (см. MustChangePassword.tsx). */\n.core-login {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-0);\n}\n.core-login-card {\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 32px;\n  border: 1px solid var(--border-1);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--bg-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
